if (!customElements.get('event-video-gallery')) {
  customElements.define('event-video-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('[data-track]');
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.index = 0;
      this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1), options);
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.go(event.key === 'Home' ? 0 : event.key === 'End' ? this.stops.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      }, { ...options, passive: true });
      this.querySelectorAll('[data-play]').forEach(button => button.addEventListener('click', () => this.play(button), options));
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.go(index);
      }, options);
      this.resize = new ResizeObserver(() => {
        this.measure();
        this.go(this.index, false);
      });
      this.resize.observe(this.track);
      this.measure();
      this.update();
    }
    disconnectedCallback() {
      this.abort.abort();
      this.resize.disconnect();
      cancelAnimationFrame(this.frame);
      this.stop();
    }
    measure() {
      const track = this.track.getBoundingClientRect();
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.stops = [...new Set(this.cards.map(card => Math.round(Math.min(max,
        Math.max(0, card.getBoundingClientRect().left - track.left + this.track.scrollLeft)))))];
      if (!this.stops.length) this.stops = [0];
      this.querySelector('.event-videos__navigation').hidden = max < 2;
      this.index = Math.min(this.index, this.stops.length - 1);
    }
    go(index, smooth = true) {
      index = Math.max(0, Math.min(index, this.stops.length - 1));
      if (index !== this.index) this.stop();
      this.index = index;
      this.track.scrollTo({ left: this.stops[index],
        behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
      this.update();
    }
    sync() {
      let nearest = 0;
      this.stops.forEach((position, index) => {
        if (Math.abs(position - this.track.scrollLeft) < Math.abs(this.stops[nearest] - this.track.scrollLeft)) nearest = index;
      });
      this.index = nearest;
      if (this.playing) {
        const media = this.playing.getBoundingClientRect();
        const track = this.track.getBoundingClientRect();
        if (media.right <= track.left || media.left >= track.right) this.stop();
      }
      this.update();
    }
    update() {
      this.querySelector('[data-prev]').disabled = this.index === 0;
      this.querySelector('[data-next]').disabled = this.index >= this.stops.length - 1;
      this.querySelector('[data-progress]').style.width = `${(this.index + 1) / this.stops.length * 100}%`;
      const track = this.track.getBoundingClientRect();
      const visible = this.cards.flatMap((card, index) => {
        const rect = card.getBoundingClientRect();
        return rect.left >= track.left - 2 && rect.right <= track.right + 2 ? [index + 1] : [];
      });
      if (visible.length) this.querySelector('[data-status]').textContent =
        `${visible[0]}${visible.length > 1 ? '–' + visible[visible.length - 1] : ''} of ${this.cards.length} events`;
    }
    stop() {
      if (!this.playing) return;
      this.playing.remove();
      this.playing = null;
      this.querySelectorAll('.is-playing').forEach(media => {
        media.classList.remove('is-playing');
        media.querySelector('[data-play]').hidden = false;
      });
    }
    play(button) {
      if (!button.dataset.videoId) return;
      this.stop();

      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(button.dataset.videoId)}?autoplay=1&rel=0&playsinline=1`;
      iframe.title = button.getAttribute('aria-label').replace(/^Play /, '');
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      button.hidden = true;
      button.parentElement.classList.add('is-playing');
      button.parentElement.append(iframe);
      this.playing = iframe;
      iframe.focus();
    }
  });
}
